import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  template: `
    <div class="row d-flex flex-column align-items-center">
      <i class="bi bi-chat-right-quote text-muted"></i>
      <h4 class="secondary mb-3 text-muted">Hi, I'm</h4>
      <h1 class="mb-3">
        <b><span> Jamal Abgudo </span> </b>
      </h1>
      <h4 class="secondary text-muted">
        I'm a Javascript developer from Kenya.
      </h4>
    </div>
  `,
  styles: [
    `
      .row {
        padding: 7em;
      }
      span {
        background: linear-gradient(transparent 70%, #ffc007 30%);
      }
      i {
        font-size: 2em;
        position: relative;
        left: -50px;
      }
    `,
  ],
})
export class AboutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
